/* Ashario Pets — generic horizontal slider used by ap-brands and any
   other section that wraps content in [data-ap-slider]. Arrow buttons
   smoothly scroll one "page" worth of content (number of fully-visible
   slides) and disappear when at the start/end. */

(function () {
  "use strict";

  const init = (slider) => {
    const track = slider.querySelector("[data-ap-slider-track]");
    const prev = slider.querySelector("[data-ap-slider-prev]");
    const next = slider.querySelector("[data-ap-slider-next]");
    if (!track) return;

    // How many slides fit fully right now? Used for "page-by-page" arrows.
    const pageSize = () => {
      const slide = track.firstElementChild;
      if (!slide) return 1;
      const slideW = slide.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return Math.max(1, Math.floor((track.clientWidth + gap) / (slideW + gap)));
    };

    const updateButtons = () => {
      const atStart = track.scrollLeft <= 1;
      // Subtract a few px to avoid floating-point rounding leaving the
      // "next" arrow visible when there's nothing to scroll to.
      const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 2;
      const canScroll = track.scrollWidth > track.clientWidth + 2;
      if (prev) prev.toggleAttribute("disabled", atStart || !canScroll);
      if (next) next.toggleAttribute("disabled", atEnd || !canScroll);
    };

    const scrollByPage = (dir) => {
      const slide = track.firstElementChild;
      if (!slide) return;
      const slideW = slide.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const distance = (slideW + gap) * pageSize();
      track.scrollBy({ left: dir * distance, behavior: "smooth" });
    };

    if (prev) prev.addEventListener("click", () => scrollByPage(-1));
    if (next) next.addEventListener("click", () => scrollByPage(1));

    track.addEventListener("scroll", () => requestAnimationFrame(updateButtons), { passive: true });

    // Keyboard nav when track has focus
    track.setAttribute("tabindex", "0");
    track.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight") { e.preventDefault(); scrollByPage(1); }
      if (e.key === "ArrowLeft")  { e.preventDefault(); scrollByPage(-1); }
    });

    // Initial state
    requestAnimationFrame(updateButtons);
    // Re-check on resize (the page size changes with breakpoint)
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => requestAnimationFrame(updateButtons), 120);
    });
  };

  document.querySelectorAll("[data-ap-slider]").forEach(init);
})();
